import React from "react";
import { view } from "@risingstack/react-easy-state";

const StockPane = () => {
  return <div className="stock-tab">Stock tab content</div>;
};

export default view(StockPane);
